import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import injectReducer from 'utils/injectReducer'
import {selectProfileType} from 'models/user/selectors'
import reducer from './reducer'
import {selectLoaded, selectAvatars, selectActiveAvatarSrc} from './selectors'
import {
  loadAvatars,
  updateAvatars,
  uploadAvatar,
  deleteAvatar,
  activateAvatar,
  resetAvatar
} from './actions'

export default function withAvatars(Component) {
  class Avatars extends PureComponent {
    static displayName = `withAvatars(${
      Component.displayName || Component.name || 'Component'
    })`

    static propTypes = {
      loaded: PropTypes.bool,
      type: PropTypes.string,
      loadAvatars: PropTypes.func,
      cancelAvatars: PropTypes.func
    }

    UNSAFE_componentWillMount() {
      const {loaded, loadAvatars} = this.props

      if (loaded === false) {
        loadAvatars()
      }
    }

    UNSAFE_componentWillReceiveProps({type, loadAvatars, cancelAvatars}) {
      if (type !== this.props.type) {
        if (type) {
          loadAvatars()
        } else {
          cancelAvatars()
        }
      }
    }

    render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {loaded, ...props} = this.props

      return <Component {...props} />
    }
  }

  const mapStateToProps = createStructuredSelector({
    type: selectProfileType,
    loaded: selectLoaded,
    avatars: selectAvatars,
    activeAvatarSrc: selectActiveAvatarSrc
  })

  function mapDispatchToProps(dispatch) {
    return {
      loadAvatars: () => dispatch(loadAvatars()),
      cancelAvatars: () => dispatch(updateAvatars(null)),
      uploadAvatar: (event) => {
        event.persist()
        dispatch(uploadAvatar(event.target.files[0]))
      },
      deleteAvatar: (id) => dispatch(deleteAvatar(id)),
      activateAvatar: (id) => dispatch(activateAvatar(id)),
      resetAvatar: () => dispatch(resetAvatar())
    }
  }

  const withConnect = connect(mapStateToProps, mapDispatchToProps)
  const withReducer = injectReducer({key: 'avatars', reducer})

  return compose(withReducer, withConnect)(Avatars)
}
